import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function TrajectoryAndCommitment() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="40468" id="potencia-y-trayectoria-de-miv-grupo" className="dark bg-background text-foreground py-32 overflow-hidden">
      <div ref={ref} className={cn("mx-auto max-w-7xl px-8 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
        <div className="grid grid-cols-1 lg:grid-cols-[55%_45%] gap-12 lg:gap-24 items-start">
          {}
          <div className="relative">
            <h2 className="text-foreground font-default font-bold tracking-tighter uppercase leading-[1] !text-3xl">MECANIZADO Y FABRICACIÓN DE ALTO NIVEL GARANTIZAMOS SU CONTINUIDAD OPERATIVA</h2>
            <div className="mt-6 h-1 w-24 bg-primary rounded-none" />
          </div>

          {}
          <div className="space-y-8">
            <p className="text-lg text-muted-foreground leading-relaxed font-sans">En MIV, ejecutamos soluciones de mecanizado de alta precisión diseñadas para maximizar la rentabilidad de sus activos. Somos especialistas en la fabricación y recuperación de componentes críticos, garantizando eficiencia absoluta en los sectores petrolero, petroquímico y de industria pesada.</p>
            <p className="text-lg text-muted-foreground leading-relaxed font-sans">
              Nuestra prioridad es eliminar tiempos de inactividad mediante intervenciones técnicas de rigor milimétrico. Fortalecemos la infraestructura industrial con estándares de calidad superior, asegurando que su planta opere a máxima capacidad y mantenga una ventaja competitiva en el mercado global.
            </p>
          </div>
        </div>
      </div>
    </section>;
}